const INITIAL_STATE = [{ role: 'USER' }];

export default function (state = INITIAL_STATE, action = []) {
    if (action.type === 'SET_USER_ROLE') {
        return [{ role: action.role, clinicId: action.clinicId, clientId: action.clientId }]
    }
    if (action.type === 'SET_CLIENT_FILTER') {
        return [{ role: action.role, clinicId: action.clinicId, clientId: action.clientId }]
    }
    return state
}